
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.8337 11.8534V11.52C33.8337 8.71976 33.8337 7.31963 33.2887 6.25007C32.8093 5.30926 32.0444 4.54435 31.1036 4.06499C30.0341 3.52002 28.6339 3.52002 25.8337 3.52002H15.167C12.3667 3.52002 10.9666 3.52002 9.89704 4.06499C8.95623 4.54435 8.19133 5.30926 7.71196 6.25007C7.16699 7.31963 7.16699 8.71976 7.16699 11.52V28.8534C7.16699 31.6536 7.16699 33.0537 7.71196 34.1233C8.19133 35.0641 8.95623 35.829 9.89704 36.3084C10.9666 36.8534 12.3667 36.8534 15.167 36.8534H21.3337M21.3337 18.52H13.8337M19.667 25.1867H13.8337M27.167 11.8534H13.8337M30.5003 30.1867V21.02C30.5003 19.6393 31.6196 18.52 33.0003 18.52C34.381 18.52 35.5003 19.6393 35.5003 21.02V30.1867C35.5003 32.9481 33.2618 35.1867 30.5003 35.1867C27.7389 35.1867 25.5003 32.9481 25.5003 30.1867V23.52","stroke":"#006ABC","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    